'use client';

import React from 'react';
import { useRouter } from 'next/navigation';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';

export default function NotFound() {
  const router = useRouter();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background px-4">
      {/* Nigerian flag accent top */}
      <div className="fixed top-0 left-0 right-0 h-1 flex pointer-events-none">
        <div className="flex-1 bg-primary" />
        <div className="flex-1 bg-transparent" />
        <div className="flex-1 bg-primary" />
      </div>

      <div className="text-center max-w-sm w-full animate-fade-in">
        {/* Logo */}
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center">
            <AppLogo size={44} />
          </div>
        </div>

        {/* 404 display */}
        <div className="mb-2">
          <span className="text-7xl sm:text-8xl font-bold text-primary/20 select-none leading-none">404</span>
        </div>

        <h1 className="text-xl sm:text-2xl font-bold text-foreground mb-2">Page Not Found</h1>
        <p className="text-muted-foreground text-sm leading-relaxed mb-8 max-w-xs mx-auto">
          This page doesn&apos;t exist or may have moved. Let&apos;s get you back to exploring Nigeria!
        </p>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            href="/"
            className="btn-primary justify-center py-3 min-h-[48px]"
          >
            Back to Home
          </Link>
          <button
            onClick={() => router?.back()}
            className="btn-secondary justify-center py-3 min-h-[48px]"
          >
            Go Back
          </button>
        </div>

        {/* Quick links */}
        <div className="mt-8 pt-6 border-t border-border">
          <p className="text-xs text-muted-foreground mb-3 font-medium uppercase tracking-wide">Quick Links</p>
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2">
            {[
              { label: 'Explore Nigeria', href: '/explore' },
              { label: 'Stories', href: '/stories' },
              { label: 'Languages', href: '/languages' },
              { label: 'Sign In', href: '/login' },
            ]?.map((link) => (
              <Link
                key={link?.href}
                href={link?.href}
                className="text-sm text-primary hover:underline font-medium min-h-[44px] flex items-center"
              >
                {link?.label}
              </Link>
            ))}
          </div>
        </div>
      </div>

      {/* Nigerian flag accent bottom */}
      <div className="fixed bottom-0 left-0 right-0 h-1 flex pointer-events-none">
        <div className="flex-1 bg-primary" />
        <div className="flex-1 bg-transparent" />
        <div className="flex-1 bg-primary" />
      </div>
    </div>
  );
}